import { getInfoSkipLoading } from '../user/actions';
import { getLkIpSkipLoading } from '../lkIp/actions';
import { startRequestSkipLoading as startRequestPropertyObjects } from '../propertyObjects/actions';

import { startRequestSkipLoading as startRequestContacts } from '../../../Contacts/redux/contacts/actions';
import { startRequestSkipLoading as startRequestMessages } from '../../../Messages/redux/messages/actions';

import { startRequestSkipLoading as startRequest2ndfl } from '../../../UserIncomes/redux/2ndfl/actions';
import { startRequestSkipLoading as startRequestIncomeInfo } from '../../../UserIncomes/redux/incomeInformations/actions';
import { startRequestSkipLoading as startRequestInsuranceTaxes } from '../../../UserIncomes/redux/insuranceTaxes/actions';
import { startRequestSkipLoading as startRequestJudicialActs } from '../../../NewTaxes/redux/judicialActs/actions';
import { startRequestSkipLoading as startRequestLiteObjects } from '../../../NewTaxes/redux/liteObjects/actions';
import { startRequestSkipLoading as startRequestOperationsHistory } from '../../../NewTaxes/redux/operationsHistory/actions';
import { startRequestSkipLoading as startRequestPdfInfo } from '../../../NewTaxes/redux/pdfInfo/actions';

import { startRequestSkipLoading as startRequestContactInfo } from '../../../Profile/redux/contactInfo/actions';
import { startRequestSkipLoading as startRequestActivityHistory } from '../../../Profile/redux/history/actions';
import { startRequestSkipLoading as startRequestPersonalData } from '../../../Profile/redux/personalData/actions';

import { startRequestSkipLoading as startRequestSnu } from '../../../Taps/redux/snu/actions';

export default [
  {
    path: 'app.propertyObjects',
    loader: startRequestPropertyObjects,
  },
  {
    path: 'app.user',
    loader: getInfoSkipLoading,
  },
  {
    path: 'app.lkIp',
    loader: getLkIpSkipLoading,
  },
  {
    path: 'contacts.contactsList',
    loader: startRequestContacts,
  },
  {
    path: 'messages.messages',
    loader: startRequestMessages,
  },
  {
    path: 'taxes.ndfl2',
    loader: startRequest2ndfl,
  },
  {
    path: 'taxes.incomeInformations',
    loader: startRequestIncomeInfo,
  },
  {
    path: 'taxes.insuranceTaxes',
    loader: startRequestInsuranceTaxes,
  },
  {
    path: 'taxes.judicialActs',
    loader: startRequestJudicialActs,
  },
  {
    path: 'taxes.liteObjects',
    loader: startRequestLiteObjects,
  },
  {
    path: 'taxes.operationsHistory',
    loader: startRequestOperationsHistory,
  },
  {
    path: 'taxes.pdfInfo',
    loader: startRequestPdfInfo,
  },
  {
    path: 'profile.contactInfo',
    loader: startRequestContactInfo,
  },
  {
    path: 'profile.history',
    loader: startRequestActivityHistory,
  },
  {
    path: 'profile.personalData',
    loader: startRequestPersonalData,
  },
  {
    path: 'taps.snu',
    loader: startRequestSnu,
  },
];
